import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: #ffffff;
  padding: 15px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 250px;
  right: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const Breadcrumb = styled.div`
  font-size: 14px;
  color: #6c757d;
  
  span {
    margin: 0 5px;
  }
  
  a {
    color: #6c757d;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  strong {
    color: #1A2440;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const Tag = styled.span`
  background-color: #f4f6f9;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #495057;
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #1A2440;
`;

interface HeaderProps {
  companyName?: string;
  sector?: string;
  location?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  companyName = "Sample Company", 
  sector = "Software", 
  location = "United States" 
}) => {
  return (
    <HeaderContainer>
      <Breadcrumb>
        <a href="/">Home</a>
        <span>{'>'}</span>
        <a href="/overview">CIM Analyzer</a>
        <span>{'>'}</span>
        <strong>{companyName}</strong>
      </Breadcrumb>
      
      <CompanyInfo>
        <Tag>{sector}</Tag>
        <Tag>{location}</Tag>
      </CompanyInfo>
      
      <MenuButton>
        ☰
      </MenuButton>
    </HeaderContainer>
  );
};

export default Header;
